import { createContext } from 'react';
import { RadioGroupContextProps } from './interfaces';

const RadioGroupContext = createContext<RadioGroupContextProps | null>(null);

export const RadioGroupContextProvider = RadioGroupContext.Provider;

export default RadioGroupContext;
